import * as microsoftTeams from "@microsoft/teams-js";
import { AuthenticationContext } from "vue-adal";
import { configuration, isInWebMode } from "./configuration";

function acquireTokenWrapperAd() {
  const clientId = configuration.clientId;
  return new Promise((resolve, reject) => {
    AuthenticationContext.acquireToken(configuration.clientId, (err: unknown, token: string) => {
      if (err) {
        const errCode = (err as string).split(":")[0];
        switch (errCode) {
          case "AADSTS50058": // Need to prompt for user sign in
            AuthenticationContext.login();
            break;
          case "AADSTS65001": // Token is invalid; grab a new one
            AuthenticationContext.acquireTokenRedirect(clientId);
            break;
          case "AADSTS16000": // No Access
          default:
            // Need a pop-up forcing a login
            AuthenticationContext.login();
            break;
        }
        reject(err);
        return;
      }
      resolve(token);
    });
  });
}

export async function acquireTokenWrapperTeams(): Promise<string | undefined> {
  return await new Promise((resolve, reject) => {
    microsoftTeams.authentication.getAuthToken({
      successCallback: (res: string) => {
        resolve(res);
      },
      failureCallback: (error: string) => {
        reject(error);
      }
    });
  });
}

export async function getBearerToken() {
  if (isInWebMode() === true) return await acquireTokenWrapperAd();
  const token = await acquireTokenWrapperTeams();
  return token;
}

export interface IToken {
  roles: string[];
  tid: string;
  oid: string;
  unique_name: string;
}

export function parseJwt(token: string): IToken {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
}

export function gotRoleInTeams(role: string, token: string) {
  if (token) {
    const parsedToken = parseJwt(token);
    if (parsedToken) {
      return parsedToken.roles.find((x) => x == role) != null;
    }
  }
  return false;
}

export async function checkRolesForUser(role: string) {
  const token = await acquireTokenWrapperTeams();
  if (token) {
    return gotRoleInTeams(role, token);
  }
  return false;
}
